import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type PremiereProjectEventsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type PremiereProjectEventsSubscription = { __typename?: 'Subscription', premiereProjectEvents: { __typename?: 'PremiereProjectClosedPayload', projectId?: string | null, projectName?: string | null } | { __typename?: 'PremiereProjectOpenedPayload', projectId?: string | null, projectName?: string | null } };


export const PremiereProjectEvents = /*#__PURE__*/ gql`
    subscription PremiereProjectEvents {
  premiereProjectEvents {
    ... on PremiereProjectOpenedPayload {
      projectId
      projectName
    }
    ... on PremiereProjectClosedPayload {
      projectId
      projectName
    }
  }
}
    ` as unknown as DocumentNode<PremiereProjectEventsSubscription, PremiereProjectEventsSubscriptionVariables>;

          

          export const usePremiereProjectEventsSubscription = (options?:SubscriptionHookOptions<PremiereProjectEventsSubscription, PremiereProjectEventsSubscriptionVariables>) => useSubscription(PremiereProjectEvents, options);

          

          export type PremiereProjectEventsSubscriptionOptions = SubscriptionHookOptions<PremiereProjectEventsSubscription, PremiereProjectEventsSubscriptionVariables>;

          

          export type PremiereProjectEventsSubscriptionResult = ReturnType<typeof usePremiereProjectEventsSubscription>;

          
